//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {mapGetters} from "vuex"

export default {

    name: "FavoriteCard",

    data() {
        return {
            isToggle: false,
        };
    },

    watch: {

        cartCount: function (newVal, oldVal) {
            if(oldVal === 0 && newVal > 0) {
                this.isToggle = true
            } else if (newVal <= 0) {
                this.isToggle = false
            }
        },

    },

    computed: {

        ...mapGetters('search', ['favoriteCart', 'companies']),

        cartCount() {
            return this.favoriteCart.length;
        },

    },

    methods: {
        // remove Item From Favorites card
        removeItemFrom(company) {
            this.$store.dispatch("search/removeFromFavorites", company);
            this.companies.find(c => {
                if (company.id === c.id) {
                    c.isLiked = false
                }
            })
        },
        // Clear All Item From Favorites card
        ClearAllFavorites() {
            this.$store.dispatch("search/ClearAllFavorites");
            this.isToggle = false
        },
        // Add Item To Request card
        addToCart(company) {
            this.$store.dispatch("search/addItem", company);
        },
        // Add  all Items To Request card
        addAllToRequest() {
            this.$store.dispatch("search/addAllToRequest");
        },


    },
}
